import type { Sale } from "../types";
import { SalesCreate } from "./SalesCreate";
import { SalesList } from "./SalesList";

// No edit page — the Users list edits everything inline (role, admin,
// disabled, names) with a staged save bar.
export default {
  list: SalesList,
  create: SalesCreate,
  recordRepresentation: (record: Sale) =>
    `${record.first_name} ${record.last_name}`,
};
